// extracted by mini-css-extract-plugin
module.exports = {"container":"spacing-module__container--3_7e2"};